// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_rEpGo {
  width: 100%;
  overflow-y: scroll;
  background: var(--f5-background);
  padding: 22px;
  border-radius: 10px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  -ms-border-radius: 10px;
  -o-border-radius: 10px;
  box-sizing: border-box;
  background-color: var(--white-color);
  border: 1px solid var(--ececf1-border);
  &::-webkit-scrollbar {
    display: none;
  }
}

.description_rKF8l {
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-bottom: 1px solid var(--ca-border);

  b {
    font-size: 16px;
    font-weight: 600;
    color: var(--_646e8a-color);
  }

  p {
    color: var(--_646e8a-color);
    margin: 4px 0px;
    line-height: 24px;
    font-size: 18px;
  }
}

.automates_bCqN6 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: auto;
  gap: 10px;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--white-color);
  list-style: none;
  align-items: center;
  margin: 0;

  @media (width<=524px) {
    & {
      grid-template-columns: repeat(1, 1fr);
    }
  }
  li {
    padding: 8px 12px;
    border-radius: 12px;
    border: 1px solid var(--e5e7eb-border);
    background: var(--white-background);
    height: 100%;
    box-sizing: border-box;
    &.disabled_hjOk3 {
      opacity: 0.5;
      cursor: not-allowed;
      button {
        display: none !important;
      }
    }
  }

  .top_iru9e {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    flex-direction: column;

    .header_DjKl4 {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      justify-content: space-between;
      width: 100%;
@media (width<=350px) {
  flex-direction: column;
}
      .icon_xW0q5 {
        min-width: 50px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid var(--ececf1-border);
        background: var(--white-background);
        @media (width<=350px) {
          margin:  0 auto;
        }
 
      }

      .info___GS3 {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        gap: 6px;

        b {
          font-size: 16px;
          font-weight: 600;
          color: var(--black-color);
        }

        p {
          font-size: 14px;
          font-weight: 400;
          color: var(--_353740-fill);
          margin: 2px 0px;
        }
      }
    }
  }

  .bottom_RuhPP {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;

    .buttons_uMJSt {
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      gap: 8px;
      width: 100%;

      button {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        max-height: 28px;
        gap: 8px;
        padding: 10px 12px;

        &.button_connect_y9XJA {
          background-color: var(--_10a37f-background);
          color: var(--white-background);
          border-radius: 20px;
          line-height: 10px;
          border: none;
        }

        &.button_added_gNgE8 {
          background-color: var(--white-background);
          border: 1px solid var(--cecece-border);
          border-radius: 20px;
          line-height: 10px;
          -webkit-border-radius: 20px;
          -moz-border-radius: 20px;
          -ms-border-radius: 20px;
          -o-border-radius: 20px;
          color: var(--_67-color);
        }
      }
    }
  }
}

.footer_FKQO5 {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/panelAutomate/IniAutomate.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB,oCAAoC;EACpC,sCAAsC;EACtC;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,yCAAyC;;EAEzC;IACE,eAAe;IACf,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,oBAAoB;EACpB,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;;EAET;IACE;MACE,qCAAqC;IACvC;EACF;EACA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,sCAAsC;IACtC,mCAAmC;IACnC,YAAY;IACZ,sBAAsB;IACtB;MACE,YAAY;MACZ,mBAAmB;MACnB;QACE,wBAAwB;MAC1B;IACF;EACF;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,sBAAsB;;IAEtB;MACE,aAAa;MACb,uBAAuB;MACvB,SAAS;MACT,8BAA8B;MAC9B,WAAW;AACjB;EACE,sBAAsB;AACxB;MACM;QACE,eAAe;QACf,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,oBAAoB;QACpB,mBAAmB;QACnB,uBAAuB;QACvB,sCAAsC;QACtC,mCAAmC;QACnC;UACE,eAAe;QACjB;;MAEF;;MAEA;QACE,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,QAAQ;;QAER;UACE,eAAe;UACf,gBAAgB;UAChB,yBAAyB;QAC3B;;QAEA;UACE,eAAe;UACf,gBAAgB;UAChB,0BAA0B;UAC1B,eAAe;QACjB;MACF;IACF;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;IACT,gBAAgB;;IAEhB;MACE,aAAa;MACb,qBAAqB;MACrB,yBAAyB;MACzB,QAAQ;MACR,WAAW;;MAEX;QACE,eAAe;QACf,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,QAAQ;QACR,kBAAkB;;QAElB;UACE,2CAA2C;UAC3C,8BAA8B;UAC9B,mBAAmB;UACnB,iBAAiB;UACjB,YAAY;QACd;;QAEA;UACE,yCAAyC;UACzC,sCAAsC;UACtC,mBAAmB;UACnB,iBAAiB;UACjB,2BAA2B;UAC3B,wBAAwB;UACxB,uBAAuB;UACvB,sBAAsB;UACtB,uBAAuB;QACzB;MACF;IACF;EACF;AACF;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV","sourcesContent":[".container {\n  width: 100%;\n  overflow-y: scroll;\n  background: var(--f5-background);\n  padding: 22px;\n  border-radius: 10px;\n  -webkit-border-radius: 10px;\n  -moz-border-radius: 10px;\n  -ms-border-radius: 10px;\n  -o-border-radius: 10px;\n  box-sizing: border-box;\n  background-color: var(--white-color);\n  border: 1px solid var(--ececf1-border);\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.description {\n  display: flex;\n  flex-direction: column;\n  padding: 10px;\n  border-bottom: 1px solid var(--ca-border);\n\n  b {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--_646e8a-color);\n  }\n\n  p {\n    color: var(--_646e8a-color);\n    margin: 4px 0px;\n    line-height: 24px;\n    font-size: 18px;\n  }\n}\n\n.automates {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-auto-rows: auto;\n  gap: 10px;\n  padding: 0;\n  box-sizing: border-box;\n  background-color: var(--white-color);\n  list-style: none;\n  align-items: center;\n  margin: 0;\n\n  @media (width<=524px) {\n    & {\n      grid-template-columns: repeat(1, 1fr);\n    }\n  }\n  li {\n    padding: 8px 12px;\n    border-radius: 12px;\n    border: 1px solid var(--e5e7eb-border);\n    background: var(--white-background);\n    height: 100%;\n    box-sizing: border-box;\n    &.disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n      button {\n        display: none !important;\n      }\n    }\n  }\n\n  .top {\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    flex-direction: column;\n\n    .header {\n      display: flex;\n      align-items: flex-start;\n      gap: 16px;\n      justify-content: space-between;\n      width: 100%;\n@media (width<=350px) {\n  flex-direction: column;\n}\n      .icon {\n        min-width: 50px;\n        width: 50px;\n        height: 50px;\n        border-radius: 50%;\n        position: relative;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid var(--ececf1-border);\n        background: var(--white-background);\n        @media (width<=350px) {\n          margin:  0 auto;\n        }\n \n      }\n\n      .info {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-start;\n        gap: 6px;\n\n        b {\n          font-size: 16px;\n          font-weight: 600;\n          color: var(--black-color);\n        }\n\n        p {\n          font-size: 14px;\n          font-weight: 400;\n          color: var(--_353740-fill);\n          margin: 2px 0px;\n        }\n      }\n    }\n  }\n\n  .bottom {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 10px;\n\n    .buttons {\n      display: flex;\n      align-items: flex-end;\n      justify-content: flex-end;\n      gap: 8px;\n      width: 100%;\n\n      button {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        max-height: 28px;\n        gap: 8px;\n        padding: 10px 12px;\n\n        &.button_connect {\n          background-color: var(--_10a37f-background);\n          color: var(--white-background);\n          border-radius: 20px;\n          line-height: 10px;\n          border: none;\n        }\n\n        &.button_added {\n          background-color: var(--white-background);\n          border: 1px solid var(--cecece-border);\n          border-radius: 20px;\n          line-height: 10px;\n          -webkit-border-radius: 20px;\n          -moz-border-radius: 20px;\n          -ms-border-radius: 20px;\n          -o-border-radius: 20px;\n          color: var(--_67-color);\n        }\n      }\n    }\n  }\n}\n\n.footer {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_rEpGo`,
	"description": `description_rKF8l`,
	"automates": `automates_bCqN6`,
	"disabled": `disabled_hjOk3`,
	"top": `top_iru9e`,
	"header": `header_DjKl4`,
	"icon": `icon_xW0q5`,
	"info": `info___GS3`,
	"bottom": `bottom_RuhPP`,
	"buttons": `buttons_uMJSt`,
	"button_connect": `button_connect_y9XJA`,
	"button_added": `button_added_gNgE8`,
	"footer": `footer_FKQO5`
};
export default ___CSS_LOADER_EXPORT___;
